import { Hero, FeaturedProduct, QuickNav } from "./components";
import { SEO, createOrganizationSchema, createWebSiteSchema, PAGE_META } from "@/components/seo";

export function Landing() {
  return (
    <>
      <SEO
        title={PAGE_META.home.title}
        description={PAGE_META.home.description}
        canonical="/"
        jsonLd={[createOrganizationSchema(), createWebSiteSchema()]}
      />
      <div className="max-w-[1470px] mx-auto px-8 py-12">
        <Hero />
        <FeaturedProduct />
        <QuickNav />
      </div>
    </>
  );
}
